/* eslint-disable @typescript-eslint/no-explicit-any */
 
import fetch from 'cross-fetch';

import AppConstants from 'constants/AppConstants';
import AppSettings from 'settings/AppSettings';

interface BankAccount {
  accountHolderType: string;
  accountNumber: string;
  country: string;
  currency: string;
  ownerName: string;
  routingNumber: string;
}

export function getPlaidClientToken(): ApiAction<string> {
  return {
    TockApi: {
      getProto: '/business/bank/client/token',
      type: AppConstants.BANK_ACCOUNT_CLIENT_TOKEN,
    },
  };
}

export function tokenizeBankAccount(bankAccount: BankAccount) {
  return (dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: AppConstants.BANK_ACCOUNT_TOKENIZE_STARTING,
      });
      return window.stripeV3
        .createToken('bank_account', {
          country: 'US',
          currency: 'USD',
          routing_number: bankAccount.routingNumber,
          account_number: bankAccount.accountNumber,
          name: bankAccount.ownerName,
          account_holder_type: bankAccount.accountHolderType,
        })
        .then((response: { error: any; token: { id: string } }) => {
          const { error, token } = response;
          if (token) {
            dispatch({
              type: AppConstants.BANK_ACCOUNT_TOKENIZE_DONE,
            });
            resolve(token.id);
          } else if (error) {
            dispatch({
              type: AppConstants.BANK_ACCOUNT_TOKENIZE_FAILED,
              toastMessage: {
                type: 'error',
                message: error.message,
              },
            });
            reject(error.message);
          } else {
            reject('There was a problem adding this bank account.');
          }
        });
    });
  };
}

export function clear(): BaseTockAction {
  return {
    type: AppConstants.BANK_ACCOUNT_CLEAR,
  };
}

export function searchBanks(query: string): Promise<unknown> {
  return fetch('https://sandbox.plaid.com/institutions/search', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      query: query,
      products: ['auth'],
      public_key: AppSettings.PLAID_PUBLIC_KEY,
    }),
  }).then((response) => {
    if (response.status !== 200) {
      throw new Error('Bad response from server');
    }
    return {
      type: AppConstants.BANK_ACCOUNT_SEARCH,
      payload: response.json().then((payload: any) => payload.institutions),
    };
  });
}
